import Backbone from 'backbone';
import $ from 'jquery';
import utils from 'app/views/store/common/utility/index';
import 'slick-carousel';
import 'jquery-zoom';

const modalThumbnailSelector = '.js-modal-thumbnail-image';
const currentImageSelector = '.js-main-image-container .slick-current .js-gallery-item';

export default Backbone.View.extend({
	el: '#js-gallery',

	events: {
		'click .js-main-image-container': '_handleMainImageClicked',
		'click .js-thumbnails': '_handleThumbnailsClicked',
		'click .js-modal-thumbnail-image': '_handleModalThumbnailClicked',
		'hide.bs.modal #js-gallery-modal': '_onModalHide'
	},

	initialize() {
		this.$mainMediaGallery = $('#product-images-container');
		this.$mainImageContainer = $('.js-main-image-container');
		this.$thumbnails = $('.js-thumbnails');
		this.maxThumbnails = 5;

		this._initSlickSliders();
		this._initZoom();
		this.listenTo(Backbone, 'finish:clicked', this._handleFinishClicked);
		this.listenTo(Backbone, 'finish:hover', utils.debounce(this._handleFinishHovered, 300));
		$(window).on('resize', this._resizeVideos);
	},

	_initSlickSliders() {
		this.$mainImageContainer.slick({
			accessibility: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: '.js-thumbnails',
			infinite: true,
			lazyLoad: 'ondemand',
			cssEase: 'linear'
		});

		const totalSlideCount = window.dataLayer.filteredMediaGallery.length;

		this.$thumbnails.slick({
			accessibility: true,
			slidesToShow: this.maxThumbnails > totalSlideCount ? this.maxThumbnails : 4,
			slidesToScroll: 1,
			asNavFor: '.js-main-image-container',
			focusOnSelect: true,
			arrows: true,
			infinite: this.maxThumbnails > totalSlideCount,
			lazyLoad: 'ondemand',
			prevArrow:
				'<button role="button" data-track-link="Image Carousel Left Arrow" type="button" class="slick-prev">Previous</button>',
			nextArrow: '<button role="button" data-track-link="Image Carousel Right Arrow" type="button" class="slick-next">Next</button>'
		});

		this.$mainImageContainer.toggleClass('is-loading');
		this.$thumbnails.toggleClass('dn');
	},

	_initZoom(index = 0) {
		const url = this._getGalleryZoomImage(index);
		this.$mainImageContainer.zoom({ url, duration: 250 });
	},
	_destroyZoom() {
		this.$mainImageContainer.trigger('zoom.destroy');
	},

	_handleMainImageClicked() {
		const activeIndex = $(currentImageSelector).data('idx');
		if (window.dataLayer.filteredMediaGallery[activeIndex].isVideo) {
			return;
		}
		this._setModalImage();
		this._setModalDescription();
		this._setModalThumbnail();
		this._setActiveModalThumbnail();
		this._launchModal();
	},

	_setModalImage() {
		const activeIndex = $(currentImageSelector).data('idx');
		const galleryImage = this._getGalleryImage(activeIndex);
		const zoomImage = this._getGalleryZoomImage(activeIndex);
		const title = window.dataLayer.filteredMediaGallery[activeIndex].TITLE;
		const alt = `${window.dataLayer.manufacturer} ${window.dataLayer.productId} ${title}`;

		$('.js-gallery-video').addClass('dn');
		$('#js-gallery-modal-image').attr({ src: galleryImage, title, alt });
		$('#js-gallery-modal-image-container').zoom({ url: zoomImage });
	},

	_setModalDescription() {
		const activeIndex = $(currentImageSelector).data('idx');
		const finish = window.dataLayer.filteredMediaGallery[activeIndex].FINISH;
		const text = window.dataLayer.filteredMediaGallery[activeIndex].TEXT;
		const $galleryModalDescription = $('#js-gallery-modal-description');
		finish ? $galleryModalDescription.text(`Finish: ${finish}`) : $galleryModalDescription.text(`Description: ${text}`);
	},

	_setModalThumbnail() {
		const selectedFinish = window.dataLayer.filteredMediaGallery[0].IMAGEPATHS[320];
		$(modalThumbnailSelector)
			.first()
			.attr('src', selectedFinish);
	},

	_setActiveModalThumbnail() {
		const activeIndex = $(currentImageSelector).data('idx');

		$(modalThumbnailSelector)
			.removeClass('b--theme-primary')
			.addClass('b--theme-grey');
		$(modalThumbnailSelector)
			.filter((_, event) => {
				return $(event).data('idx') === activeIndex;
			})
			.removeClass('b--theme-grey')
			.addClass('b--theme-primary');
	},

	_launchModal() {
		$('#js-gallery-modal').modal('show');
		Backbone.trigger('omniture:clicktracking', 'media gallery:opened');
		this._checkAffixedGallery();
	},
	_getFilteredImageData(index = 0) {
		const { filteredMediaGallery } = window.dataLayer;
		return filteredMediaGallery[index] || filteredMediaGallery[0];
	},
	_getGalleryImage(index) {
		const image = this._getFilteredImageData(index);
		return image.IMAGEPATHS && image.IMAGEPATHS[800];
	},

	_getGalleryZoomImage(index) {
		const image = this._getFilteredImageData(index);
		return image.IMAGEPATHS && image.IMAGEPATHS[1200];
	},

	_handleThumbnailsClicked() {
		this._updateZoomImageFromThumbnail();
		this._updateActiveThumbnail();
		Backbone.trigger('videos:pause');
	},

	_updateZoomImageFromThumbnail() {
		const activeIndex = $(currentImageSelector).data('idx');
		const image = this._getGalleryZoomImage(activeIndex);
		if (!image) {
			this._destroyZoom();
			$('.js-main-image-container .zoomImg').addClass('dn');
		} else {
			this._initZoom(activeIndex);
			$('.js-main-image-container .zoomImg').removeClass('dn');
			$('.js-main-image-container .zoomImg').attr('src', image);
		}
	},

	_updateActiveThumbnail() {
		const activeIndex = $('.js-thumbnails').slick('slickCurrentSlide');

		$('.js-thumbnails .slick-slide img').removeClass('ba br2 b--theme-grey pa1');
		$('.js-thumbnails .slick-current img')
			.filter((_, event) => {
				return $(event).data('idx') === activeIndex;
			})
			.addClass('ba br2 b--theme-grey pa1');
	},

	_handleModalThumbnailClicked(e) {
		this._updateModalImage(e);
		this._updateModalDescription(e);
		this._updateActiveModalThumbnail(e);
		Backbone.trigger('videos:pause');
	},

	_updateModalImage(e) {
		const { filteredMediaGallery, manufacturer, productId } = window.dataLayer;
		const activeIndex = $(e.target).data('idx');
		if (Number.isInteger(activeIndex)) {
			const galleryImage = this._getGalleryImage(activeIndex);
			const zoomImage = this._getGalleryZoomImage(activeIndex);
			const title = filteredMediaGallery[activeIndex].TITLE;
			const alt = `${manufacturer} ${productId} ${title}`;
			// if video append a video instead
			$('.js-gallery-video').addClass('dn');
			if (!zoomImage) {
				this._destroyZoom();
				$('#js-gallery-modal-image-container .zoomImg').addClass('dn');
				$('.gallery-modal-image').addClass('dn');
				$(`.js-video-${filteredMediaGallery[activeIndex].video.hashKey}`).removeClass('dn');
				$('#js-gallery-modal-image-container').trigger('zoom.destroy');
				this._resizeVideos();
			} else {
				$('.gallery-modal-image')
					.removeClass('dn')
					.attr({ src: galleryImage, title, alt });

				$('#js-gallery-modal-image-container .zoomImg').removeClass('dn');
				$('#js-gallery-modal-image-container .zoomImg').attr('src', zoomImage);
				$('#js-gallery-modal-image-container').zoom({ url: zoomImage });
			}
		}
	},

	_updateModalDescription(e) {
		const activeIndex = $(e.target).data('idx');
		const galleryItem = window.dataLayer.filteredMediaGallery[activeIndex];
		const finish = galleryItem.FINISH;
		let text = galleryItem.TEXT;
		if (galleryItem.isVideo) {
			text = galleryItem.video.description;
		}
		const $galleryModalDescription = $('#js-gallery-modal-description');

		finish ? $galleryModalDescription.text(`Finish: ${finish}`) : $galleryModalDescription.text(`Description: ${text}`);
	},

	_updateActiveModalThumbnail(e) {
		const activeIndex = $(e.target).data('idx');

		$(modalThumbnailSelector)
			.removeClass('b--theme-primary')
			.addClass('b--theme-grey');
		$(modalThumbnailSelector)
			.filter((_, event) => {
				return $(event).data('idx') === activeIndex;
			})
			.removeClass('b--theme-grey')
			.addClass('b--theme-primary');
	},

	_handleFinishClicked(finish) {
		const hasFinishImage = this._hasFinishImage(finish);
		this._updateFilteredMediaGallery(finish);

		$('#js-no-finish-image').remove();

		if (hasFinishImage) {
			this._handleFinishClickedHasFinishImage(finish);
		} else {
			this._handleFinishClickedHasNoFinishImage(finish);
		}
	},

	_updateFilteredMediaGallery(finish) {
		const galleryFinish = window.dataLayer.filteredMediaGallery[0];
		galleryFinish.FINISH = finish.finish;
		galleryFinish.TITLE = finish.name;

		if (finish.images) {
			galleryFinish.IMAGEPATHS = finish.images;
		}
	},

	_hasFinishImage(finish) {
		if (finish.images) {
			return finish.images[50].indexOf('noimage.gif') === -1;
		} else if (finish.image) {
			return finish.image.indexOf('noimage.gif') === -1;
		} else {
			return false;
		}
	},

	_handleFinishClickedHasFinishImage(finish) {
		if (finish.images) {
			this._updateZoomImage(finish);
			this._updateGalleryImageFromClick(finish);
			this._updateFinishThumbnail(finish);
			this._navigateToFinishThumbnail();
		}
		this._updateActiveThumbnail();
	},

	_handleFinishClickedHasNoFinishImage(finish) {
		this._showNoFinishText(finish);
	},

	_handleFinishHovered(finish) {
		const hasFinishImage = this._hasFinishImage(finish);

		$('#js-no-finish-image').remove();
		$('#js-finish-hover-image').remove();

		if (hasFinishImage) {
			this._handleFinishHoveredHasFinishImage(finish);
		} else {
			this._handleFinishHoveredHasNoFinishImage(finish);
		}
	},

	_handleFinishHoveredHasFinishImage(finish) {
		const html = `
			<div id="js-finish-hover-image" class="absolute bg-theme-white left-0 right-0 top-0 bottom-0 flex items-center justify-center pa3">
				<img class="inline-flex" src="${finish.images[450]}" alt="${finish.finish}">
			</div>
		`;

		if (!finish.selected) {
			this.$mainImageContainer.append(html);
		}
	},

	_handleFinishHoveredHasNoFinishImage(finish) {
		this._showNoFinishText(finish);
	},

	_updateGalleryImageFromClick(finish) {
		this._updateGalleryImageFromFilteredMediaGallery();
		this._updateFinishGalleryImage(finish);
	},

	_updateGalleryImageFromFilteredMediaGallery() {
		const index = $('.js-thumbnails').slick('slickCurrentSlide');
		$('.js-main-image-container .slick-active img').attr('src', window.dataLayer.filteredMediaGallery[index].IMAGEPATHS[450]);
	},

	_updateActiveGalleryImageFromFinish(finish) {
		$('.js-main-image-container .slick-active img').attr('src', finish.images[450]);
	},

	_updateFinishGalleryImage(finish) {
		$('.js-main-image-container .product-gallery__main-image')
			.filter((_, event) => {
				return $(event).data('idx') === 0;
			})
			.attr('src', finish.images[450]);
	},

	_updateZoomImage(finish) {
		$('.js-main-image-container .zoomImg').attr('src', finish.images[1200]);
	},

	_updateFinishThumbnail(finish) {
		$('.js-thumbnails .product-gallery__thumbnail-image')
			.filter((_, event) => {
				return $(event).data('idx') === 0;
			})
			.attr('src', finish.images[100]);
	},

	_navigateToFinishThumbnail() {
		this.$thumbnails.slick('slickGoTo', 0);
	},

	_showNoFinishText(finish) {
		const finishMessage = finish.finish ? finish.finish : 'this finish';
		const html = `
			<div id="js-no-finish-image" class="absolute left-0 right-0 top-0 bottom-0 flex items-center justify-center">
				<div class="bg-theme-grey-o75 ph4 pv3 inline-flex b">Photo not available for ${finishMessage}</div>
			</div>
		`;
		this.$mainImageContainer.append(html);
	},

	// Since the gallery may be affixed and modal is inside the affixed gallery
	// we need to reset the gallery.
	_checkAffixedGallery() {
		if (this.$mainMediaGallery.hasClass('affix')) {
			this.$mainMediaGallery.removeClass('affix');
			this.wasAffixed = true;
		}
	},

	_onModalHide() {
		if (this.wasAffixed) {
			this.$mainMediaGallery.addClass('affix');
			this.wasAffixed = false;
		}
	},
	_resizeVideos() {
		const width = $('.js-modal-gallery').width();
		$('.js-gallery-video').css({
			height: width / 2,
			width
		});
	}
});
